interface className {
    className?: string;
}

const Pie = ({className}:className) => (
    <svg viewBox="0 0 341 303" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M37.9998 151.531C37.9932 119.152 48.3601 87.6235 67.5805 61.567C86.8009 35.5105 113.864 16.2971 144.801 6.74411C175.738 -2.80892 208.922 -2.19907 239.487 8.48418C270.052 19.1674 296.391 39.3621 314.641 66.1072C332.891 92.8523 342.093 124.741 340.896 157.097C339.7 189.454 328.169 220.576 307.994 245.9C287.819 271.225 260.061 289.419 228.79 297.816C197.52 306.214 164.381 304.371 134.234 292.56L189.5 151.5L37.9998 151.531Z" fill="#FF9300"/>
        <path d="M32.5333 155.599C32.5685 178.318 37.713 200.739 47.5858 221.2C57.4587 241.662 71.8071 259.641 89.5689 273.807L184.033 155.364L32.5333 155.599Z" fill="#1B86ED"/>
        <path d="M89.6878 273.902C101.484 283.291 114.616 290.866 128.65 296.378L184.034 155.364L89.6878 273.902Z" fill="#F9FB2A"/>
    </svg>
)

export default Pie;